import React from 'react';
import SummaryDisplayChat from '../../MicroProbe/Companies/SummaryDisplay_Chat';

const SummaryDisplayChatLongTerm = ({ content }) => {
  let text = content;

  // If it's a plain object, extract .response field
  if (content && typeof content === 'object') {
    text = content.response || JSON.stringify(content);
  }

  // If it's a string that looks like JSON, try to parse and extract .response
  if (typeof text === 'string') {
    const trimmed = text.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('"')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed === 'object' && parsed.response) {
          text = parsed.response;
        } else if (typeof parsed === 'string') {
          text = parsed;
        }
      } catch (e) {
        // not JSON, use as-is
      }
    }
  }

  // Clean up any <br/> tags the backend may inject
  text = String(text)
    .replace(/<br\s*\/?>/gi, '\n')
    .trim();

  return <SummaryDisplayChat content={text} />;
};

export default SummaryDisplayChatLongTerm;
